$(document).ready(function(){
  $('.ctm_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
     prevArrow: '<button class="slide-arrow prev-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.8301 20.1523L0.830078 10.6523L10.8301 1.15234" stroke="#312D2B" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.17017 20.1523L11.1702 10.6523L1.17017 1.15234" stroke="#312D2B" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    asNavFor: '.product-thumbnails',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

$('.product-thumbnails').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.ctm_slider',
  dots: false,
  infinite: true,
  focusOnSelect: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]
});


  $('.announce').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  dots: false,
      responsive: [
      {
        breakpoint: 989,
        settings: {
        autoplay:true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
        }
      }
    ]
});
  
  $(document).on('click','.product-thumbnails__item-link',function(){
    var getIndex = $(this).data('index');
    $('.ctm_slider').slick('slickGoTo', getIndex);
});

  

  
});

$(document).on('click','.ctm_slider .image',function(){
  var getId = $(this).data('id');
  let btn = document.querySelector('[data-open="'+getId+'"]');
  let clickEvent = new Event('click');
  btn.dispatchEvent(clickEvent);
})

    $(document).on('click' , '.product__meta .product__color-chips button' , function() {
      setTimeout(function() {
debugger
        var varId = $(document).find('.product-form__variants [name="id"] option:selected').data('image-id');
        $('.custom_thumbnails').find(`button[data-thumbnail-id="${varId}"] .product-thumbnails__item-image`).trigger("click")
      }, 500);
    });

    $(document).on('change' , '.product__meta .select-wrapper .input' , function() {
      setTimeout(function() {
        var varId = $(document).find('.product-form__variants [name="id"] option:selected').data('image-id');
        $('.custom_thumbnails').find(`button[data-thumbnail-id="${varId}"] .product-thumbnails__item-image`).trigger("click")
      }, 500);
    });
 $(document).on('click' , '.quick-cart__footer button' , function() {
   window.location.href = "/checkout"
 })
 $(document).on('click' , 'button[data-increase],button[data-remove],button[data-decrease]' , function() {
  setInterval(function() {
    $('.quick-cart__footer .quick-cart__buy-now').attr('href', '/checkout');
  },200)
 })
$(window).on("load", function () {
   $('.quick-cart__footer .quick-cart__buy-now').attr('href', '/checkout');
});
